import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  api: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  apiContent: {
    maxWidth: 600,
    width: '100%',
    background: 'white',
    border: '1px solid #D9D9D9',
    padding: 24,
  },
  buttonLoading: {
    marginLeft: 10,
    position: 'relative',
    top: 2,
  },
  head: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 600,
    alignItems: 'center',
    position: 'relative',
    '& #config-api-button': {
      position: 'absolute',
      right: 0,
      top: 0,
      [theme.breakpoints.down('xs')]: {
        position: 'relative',
        marginBottom: theme.spacing(2),
        alignSelf: 'flex-end',
      },
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
    },
  },
  title: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    marginBottom: 24,
    textAlign: 'center',
    ['& h1']: {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    ['& p']: {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
  info: {
    paddingTop: 8,
    paddingBottom: 8,
    fontWeight: 300,
  },
  listTitle: {
    color: '#192542',
    fontWeight: 500,
    marginBottom: 6,
  },
  createdAt: {
    fontSize: 12,
    color: theme.palette.grey[600],
  },
}));

export default styles;
